import styled from "styled-components";

export const UnitsContainer = styled.div`
    background: #FCFCFC;
    display: flex;
    flex-direction: column;
    padding: 28px 0;

    div.units-information {
        display: flex;
        flex-direction: column;
        gap: 55px;
        justify-content: center;

        @media (min-width: 720px) {
            flex-direction: row;
        }

        @media (orientation: landscape) and (max-width: 1080px){
            flex-direction: column;
        }
    }

    div.info-card {
        background: #FFF;
        border-radius: 8px;
        box-shadow: 1.75px 1.751px 1.751px 0 rgba(0, 0, 0, 0.15);
        padding: 8px;

        h3 {
            color: #333;
            font-size: 20px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin-bottom: 1rem;
            text-align: center;
            text-transform: capitalize;
        }

        th { 
            color: #333;
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            text-transform: uppercase;
        }

        table { 
            border-collapse: collapse;
            width: 100%;
        }

        th, td { 
            line-height: 28px;
            padding: 4px 12px;
            text-align: left;
        }
    }

    div.units-grid {
        display: flex;
        flex-direction: column;
        gap: 16px;

        @media (min-width: 720px) {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
        }

        @media (orientation: landscape) and (max-width: 1080px){
            display: grid;
            grid-template-columns: repeat(2, 1fr);
        }

        .card {
            align-items: center;
            background: #FFF;
            border-radius: 8px;
            box-shadow: 1.75px 1.751px 1.751px 0 rgba(0, 0, 0, 0.15);
            display: flex;
            flex-direction: column;
            height: fit-content;
            min-width: max-content;
            padding: 12px;

            h4 {
                color: #333;
                font-size: 14px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
                margin-bottom: 8px;
                text-align: center;
                text-transform: uppercase;
            }

            .options-wrapper {
                display: flex;
                flex-direction: column;
                flex-wrap: wrap;
                height: 100px;
                padding: 0 18px;
                width: 100%;
            }
        }

        .card.large .options-wrapper {
            height: 80px;
        }

        .card.small .options-wrapper {
            height: 40px;
        }

        .card.center .options-wrapper {
            align-items: center;
        }
    }

    .button-container {
        display: flex;
        justify-content: flex-start;
        margin-top: 20px;
        width: 100%;
        
        @media (min-width: 720px) {
            justify-content: flex-end;
            padding: 0 42px;
        }

        @media (orientation: landscape) and (max-width: 1080px){
            justify-content: flex-start;
        }
    }
`;

export const Title = styled.h1`
    color: #333;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-bottom: 24px;
    padding: 10px 0;
    text-align: center;
    width: 100%;
`;